module.exports = __webpack_public_path__ + "img/card9.a6b848b8.jpg";